"use client"

import Breadcrumb from "components/Breadcrumb/Breadcrumb";
import { slugToString } from "functions/slug";
import { useRouter } from "next/router";


export default function ProductDetailBreadcrumb({ categorySlug }: { categorySlug?: string }) {

    const router = useRouter();
    const category = categorySlug ?? router.query.category as string;   
    const dataBreadcrumb = [
        {
        id: 1,
        href: '',
        text: 'Home'
        },
        {
        id: 2,
        href: 'shop',
        text: 'Shop'
        },
        {
        id: 3,
        href: `shop/${category}`,
        text: slugToString(category)
        },
        {
        id: 4,
        href: `shop/${category}/${router.query.product}`,
        text: slugToString(router.query.product as string)
        }
    ];
    
    return (<Breadcrumb data={dataBreadcrumb} />);
}